<template>
  <div id="web-traffic-dashboard" class="wt-dashboard">
    <!-- KPI Cards -->
    <div class="stats-grid" style="grid-template-columns: repeat(3, 1fr)">
      <!-- Total Sessions -->
      <div class="stat-card">
        <div class="stat-label">👥 Total Sessions (30d)</div>
        <div class="stat-row">
          <span class="stat-value">{{ fmt(data.totalSessions.total) }}</span>
          <span class="stat-sub">avg {{ fmt(data.totalSessions.dailyAvg) }}/day</span>
        </div>
      </div>

      <!-- Contact Click Sessions -->
      <div class="stat-card">
        <div class="stat-label">📞 Contact Click Sessions</div>
        <div class="stat-row">
          <span class="stat-value" style="color: var(--accent-green)">{{ fmt(data.totalSessions.contactClicks) }}</span>
          <span class="stat-sub">avg {{ fmt(data.totalSessions.contactClicksDailyAvg) }}/day</span>
        </div>
      </div>

      <!-- Conversion Ratio -->
      <div class="stat-card">
        <div class="stat-label">🎯 Conversion Ratio</div>
        <div class="stat-row">
          <span class="stat-value" style="color: var(--accent-yellow)">{{ data.totalSessions.ratio }}%</span>
        </div>
      </div>
    </div>

    <!-- Traffic Source Breakdown -->
    <div class="chart-box">
      <div class="chart-title">Traffic Source Breakdown</div>
      <div class="wt-source-list">
        <div
          v-for="src in data.sources"
          :key="src.key"
          class="wt-source-row"
        >
          <div class="wt-source-label">
            <span class="wt-source-icon">{{ src.icon }}</span>
            <span>{{ src.label }}</span>
          </div>
          <div class="wt-source-bar-track">
            <div
              class="wt-source-bar-fill"
              :style="{ width: barWidth(src.total) + '%', background: sourceColor(src.key) }"
            ></div>
          </div>
          <div class="wt-source-stats">
            <span class="wt-source-total">{{ fmt(src.total) }}</span>
            <span class="wt-source-detail">
              clicks: {{ fmt(src.contactClicks) }} · ratio: {{ src.ratio }}%
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  data: { type: Object, required: true },
})

const maxTotal = computed(() =>
  Math.max(...props.data.sources.map(s => s.total), 1)
)

function barWidth(total) {
  return Math.max((total / maxTotal.value) * 100, 1)
}

function fmt(n) {
  return n.toLocaleString('id-ID')
}

const SOURCE_COLORS = {
  returning: 'var(--accent-purple)',
  organic: 'var(--accent-green)',
  ads: 'var(--accent-blue)',
  direct: 'var(--accent-yellow)',
  other: 'var(--text-dim)',
}

function sourceColor(key) {
  return SOURCE_COLORS[key] || 'var(--text-dim)'
}
</script>
